import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComplianceApiService } from '../../../_core/_services/_compliance/compliance-api.service';
import { NotificationService } from '../../../_core/_services/notification.service';

@Component({
  selector: 'app-compliance-resubmit',
  standalone: false,
  templateUrl: './compliance-resubmit.html',
  styleUrl: './compliance-resubmit.css',
})
export class ComplianceResubmit implements OnInit {
  applicationId = '';
  clearPreviousReviewNotes = true;
  loading = false;
  error: string | null = null;
  success: string | null = null;

  constructor(
    private notifyService: NotificationService,
    private route: ActivatedRoute,
    private router: Router,
    private api: ComplianceApiService
  ) {}

  ngOnInit(): void {
    this.applicationId = this.route.snapshot.paramMap.get('applicationId') || '';
  }

  submit(): void {
    if (!this.applicationId) {
      this.error = 'Application not found.';
      return;
    }

    this.loading = true;
    this.error = null;
    this.success = null;

    this.api.resubmit(this.applicationId, {
      clearPreviousReviewNotes: this.clearPreviousReviewNotes
    }).subscribe({
      next: (res) => {
        this.loading = false;
        this.success = res?.message || 'Application resubmitted successfully.';
        this.router.navigate(['/compliance/wizard', this.applicationId]);
      },
      error: (err) => {
        this.loading = false;
        this.error = err?.error?.message || 'Unable to resubmit application.';
        this.notifyService.showError(this.error!, 'Error');
      }
    });
  }
}